enum RegistrationWorkflowType {
  APPLICATION = "APPLICATION",
  PAYMENT_NO_APPROVAL = "PAYMENT_NO_APPROVAL",
  PAYMENT_MANDATORY_APPROVAL = "PAYMENT_MANDATORY_APPROVAL",
  PAYMENT_FIRST_APPROVAL_FROM_ORG = "PAYMENT_FIRST_APPROVAL_FROM_ORG",
  NON_ATTENDEE_REG_ADMIN = "NON_ATTENDEE_REG_ADMIN",
  TICKET_PURCHASE = "TICKET_PURCHASE",
  TICKET_TRANSFER = "TICKET_TRANSFER",
  NON_ATTENDEE_APPLICATION = "NON_ATTENDEE_APPLICATION",
  NON_ATTENDEE_NO_APPROVAL = "NON_ATTENDEE_NO_APPROVAL",
  TICKET_ASSIGNMENT = "TICKET_ASSIGNMENT",
  ATTENDEE_REG_ADMIN = "ATTENDEE_REG_ADMIN",
  PAYMENT_NO_APPROVAL_NO_CONFLICTS = "PAYMENT_NO_APPROVAL_NO_CONFLICTS",
  NON_ATTENDEE_PAYMENT = "NON_ATTENDEE_PAYMENT"
}

export const TICKET_DESCRIPTION_OPTIONAL_WORKFLOWS = [
  RegistrationWorkflowType.PAYMENT_FIRST_APPROVAL_FROM_ORG,
  RegistrationWorkflowType.PAYMENT_MANDATORY_APPROVAL,
  RegistrationWorkflowType.PAYMENT_NO_APPROVAL,
  RegistrationWorkflowType.PAYMENT_NO_APPROVAL_NO_CONFLICTS,
  RegistrationWorkflowType.NON_ATTENDEE_PAYMENT
];

export default RegistrationWorkflowType;
